import React from "react";
import QuantitySelector from "../../assets/QuantitySelector";
import { addProduct } from "../../actions/basket";
import LoginModal from "./LoginModal";
import Variant from "./Variant";
import AddOnList from "./AddOnList";
import { Spinner } from "../../assets";
import { findProductQuantity } from ".";
import { useModal } from "../../assets/useModal";
import { useSelector, useDispatch } from "react-redux";

export default function ProductSelector({ product, variants, onStartConfiguring, featureColor }) {

	const dispatch = useDispatch();
	const { closeModal, setModal } = useModal();
	const { basket, user, addOns } = useSelector(state => ({
		basket: state.basket,
		user: state.session.user && state.session.user.id ? state.session.user : null,
		addOns: state.vendor.addOns
	}));
	const quantity = findProductQuantity(product, basket);
	const basketTotal = basket.items.reduce((acc, item) => acc + (item.quantity * item.product.price), 0);

	return <>
		<div className="product-text padded2">
			<h4 className="featureFont">{product.name}</h4>
			<h5 style={{
				color: featureColor || "#000000"
			}}>{product.category}</h5>
			{Boolean(product.description) && <>
				<br />
				<div>{product.description}</div>
			</>}
		</div>
		{!product.restricted && <div className="controls noSelect padded2 bordered-top">
			<div className="price featureFont">
				£{(product.price / 100).toFixed(2)}
			</div>
			{Boolean(product.options && product.options.length) ?
				(
					<button
						className="style-2"
						onClick={e => {
							if (!user) {
								setModal(<LoginModal />, "login");
							} else {
								onStartConfiguring(product);
							}
						}}
					>Add<span className="brand-c">+</span></button>
				) : (
					<QuantitySelector
						showWhenDisabled={true}
						value={quantity}
						onChange={newQuantity => {
							if (!user) {
								setModal(<LoginModal />, "login");
							} else {
								dispatch(addProduct(
									{ ...product, options: [] },
									newQuantity - quantity)
								);
							}
						}}
					/>
				)}
		</div>}

		{/* Base product's add-ons */}
		{Boolean(quantity) && <AddOnList
			featureColor={featureColor}
			addOns={(product.addOns || [])
				.map(addOn => ({ ...addOn, addOn: addOns.find(a => addOn.addOn === a.id) }))
				.filter(a => a.addOn)
			}
		/>}

		{/* Product Variants */}
		{Boolean(variants.length) && <div className="variants">
			{variants.sort((a, b) => a.price - b.price)
				.map(variant => <Variant
					key={variant.id}
					variant={variant}
					product={product}
					onStartConfiguring={onStartConfiguring}
				/>)
			}
		</div>}

		{/* If you're logged in, show current basket display. */}
		{Boolean(user) ?
			<button
				onClick={closeModal}
				className="chunky"
			>{basket.loading ? <Spinner /> : <b style={{ color: "#aaaaaa" }}>All done? <span style={{ color: "#ffffff" }}>£{(basketTotal / 100).toFixed(2)}</span> in basket</b>}</button>
			:
			<div className="spacer" style={{ height: 20 }} />
		}
	</>
}